import * as React from 'react';
import { styled } from 'styled-components';
import { slateGrey, superLightGreyColour, tabletPortraitMinWidth } from '../../cssConstants';
import FormButtons from './FormButton';

const HeaderCardSection = ({
	imageSrc,
	imageAlt = '',
	imageIsFullWidth = true,
	title,
	descriptions,
	titleFontSize,
	descriptionFontSize,
	buttonText,
	onButtonClick
}: Props) => {
	return (
		<Card>
			{imageSrc && (
				<ImgWrapper>
					<Img src={imageSrc} alt={imageAlt} isFullWidth={imageIsFullWidth} />
				</ImgWrapper>
			)}
			<Title fontSize={titleFontSize}>{title}</Title>
			{descriptions.map((desc) => (
				<Description key={desc} fontSize={descriptionFontSize}>
					{desc}
				</Description>
			))}
			{onButtonClick && (
				<StartButton continueButtonText={buttonText} onContinueButtonClick={onButtonClick} buttonPaddingTop="0" />
			)}
		</Card>
	);
};

export default HeaderCardSection;

interface Props {
	imageSrc?: string;
	imageAlt?: string;
	imageIsFullWidth?: boolean;
	title: string;
	descriptions: string[];
	titleFontSize?: string;
	descriptionFontSize?: string;
	buttonText?: string;
	onButtonClick?: () => void;
}

const Card = styled.div`
	margin-bottom: 16px;
`;

const ImgWrapper = styled.div`
	position: relative;
	width: 100%;
	border-radius: 14px;
	overflow: hidden;
	display: flex;
`;

const Img = styled.img<{ isFullWidth?: boolean }>`
	width: ${(props) => (props.isFullWidth ? '100%' : 'initial')};
	margin-inline: auto;
`;

const Title = styled.p<{ fontSize?: string }>`
	color: ${slateGrey};
	padding-top: 16px;
	font-size: ${(props) => props.fontSize || '16px'};
	font-weight: 500;
	line-height: 24px;
	letter-spacing: 0.15px;

	@media (min-width: ${tabletPortraitMinWidth}) {
		font-size: 18px;
	}
`;

const Description = styled.div<{ fontSize?: string }>`
	color: ${superLightGreyColour};
	padding-top: 10px;
	font-size: ${(props) => props.fontSize || '14px'};
	font-weight: 400;
	line-height: ${(props) => (props.fontSize ? '16.5px' : '20px')};
	letter-spacing: 0.25px;

	@media (min-width: ${tabletPortraitMinWidth}) {
		font-size: 16px;
		line-height: 24px;
	}
`;

const StartButton = styled(FormButtons)`
	margin: 0;
	margin-top: 22px;
`;
